import { render, staticRenderFns } from "./progettiDaFatturare.vue?vue&type=template&id=2b9d2c16"
import script from "./progettiDaFatturare.vue?vue&type=script&lang=js"
export * from "./progettiDaFatturare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports